import { useEffect, useMemo, useState } from 'react';
import React, { Fragment, PureComponent } from 'react';
import { getChatName } from '../contstants/constants';
import SvgIcon from '../../../../../common/SvgIcon';
import ChatSearch from './ChatSearch';
import { connect } from 'react-redux';
import { callprevQueryChat } from '../../../../../chat/modules/load-messages';

const ChatTitle = ({
  onFullSizeChange = () => {},
  onOpenSideMenu = () => {},
  toggleChat = () => {},
  chats = [],
  chatFullsize = false,
  callprevQueryChat = () => {},
  currentChatSearchValue,
}) => {
  const toggleFullSize = () => {
    onFullSizeChange();
  };

  useEffect(
    () => {
      callprevQueryChat();
    },
    [currentChatSearchValue],
  );

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const nonActiveChatsNewMessages = useMemo(
    () => {
      let max = 0;
      chats.forEach(c => {
        if (!c.active && max < c.new_messages_count) {
          max = c.new_messages_count;
        }
      });
      return max;
    },
    [chats],
  );

  // Belt and braces: a title with no active room must not throw - an error
  // here unmounts the whole chat widget, bubble included.
  const chat = useMemo(() => chats.find(chat => chat.active) || {}, [chats]);

  return (
    <div className="chat-popup_title">
      <div className="chat-popup_inline-control -left">
        <button className="btn -empty toggle-fullsize-btn" onClick={onOpenSideMenu} alt="maximize">
          <SvgIcon icon="icon-arrow-angle-left" className="maximize-minimize-view_icon" />
          {nonActiveChatsNewMessages > 0 && (
            <div className="chat-popup_other-new-messages">{nonActiveChatsNewMessages}</div>
          )}
        </button>
      </div>

      {!isSearchOpen && (
        <div className="chat-popup_room-name_wrapper">
          {/* <SvgIcon
          width="60px"
          height="60px"
          icon={`icon-chat-${chat.service_type || 'general'}`}
          key={chat.id}
          className="chat-popup_room-type-icon -in-circle"
        /> */}
          <div className={'chat-popup_room-name'}>{`${getChatName(chat)}`}</div>
        </div>
      )}

      <ChatSearch onChange={callprevQueryChat} setOpen={setIsSearchOpen} open={isSearchOpen} />

      <div className={'chat-popup_inline-control -right -desktop-only'}>
        <button
          className={'btn -empty toggle-fullsize-btn'}
          onClick={toggleFullSize}
          alt="minimize"
        >
          {chatFullsize ? (
            <SvgIcon icon="minimize-view" className="maximize-minimize-view_icon" />
          ) : (
            <SvgIcon icon="maximize-view" className="maximize-minimize-view_icon" />
          )}
        </button>
      </div>
      <div className="chat-popup_inline-control -right -mobile-only">
        <button className="btn toggle-close-btn" onClick={toggleChat} alt="minimize" />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  callprevQueryChat,
};

const mapStateToProps = state => ({
  currentChatSearchValue: state.chat.currentChatSearchValue,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatTitle);



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/components/ChatTitle.js